export default class NumString {
  static typeSearch = "local"; //online || local

  constructor(data = null) {}

  num2str(num, moneda) {
    moneda = moneda || (num !== 1 ? "pesos" : "peso");
    var fraction = Math.round(this.__cf_frac(num) * 100);
    var f_text = " (" + this.pad(fraction, 2) + "/100 M.N.)";

    return this.__cf_convert_number(num) + " " + moneda + f_text;
  }

  __cf_frac(f) {
    return f % 1;
  }
  __cf_convert_number(number) {
    if (number < 0 || number > 999999999) {
      throw Error("N\u00famero fuera de rango");
    }
    var millon = Math.floor(number / 1000000);
    number -= millon * 1000000;
    var cientosDeMiles = Math.floor(number / 100000);
    number -= cientosDeMiles * 100000;
    var miles = Math.floor(number / 1000);
    number -= miles * 1000;
    var centenas = Math.floor(number / 100);
    number = number % 100;
    var tn = Math.floor(number / 10);
    var one = Math.floor(number % 10);
    var res = "";

    var cientos = Array(
      "",
      "cien",
      "doscientos",
      "trescientos",
      "cuatrocientos",
      "quinientos",
      "seiscientos",
      "setecientos",
      "ochocientos",
      "novecientos"
    );
    if (millon > 0) {
      res +=
        this.__cf_convert_number(millon) +
        (millon === 1 ? " mill\u00f3n" : " millones");
    }
    if (cientosDeMiles > 0) {
      res +=
        (res == "" ? "" : " ") +
        cientos[cientosDeMiles] +
        (miles > 0 || centenas > 0 || tn > 0 || one < 0
          ? cientosDeMiles == 1
            ? "to "
            : " "
          : "");
    }
    if (miles > 0) {
      res += (res == "" ? "" : " ") + this.__cf_convert_number(miles) + " mil";
    }
    if (centenas) {
      res +=
        (res == "" ? "" : " ") +
        cientos[centenas] +
        (tn > 0 || one > 0 ? (centenas > 1 ? " " : "to ") : "");
    }

    var ones = Array(
      "",
      "un",
      "dos",
      "tres",
      "cuatro",
      "cinco",
      "seis",
      "siete",
      "ocho",
      "nueve",
      "diez",
      "once",
      "doce",
      "trece",
      "catorce",
      "quince",
      "dieciseis",
      "diecisiete",
      "dieciocho",
      "diecinueve"
    );
    var tens = Array(
      "",
      "",
      "veinte",
      "treinta",
      "cuarenta",
      "cincuenta",
      "sesenta",
      "setenta",
      "ochenta",
      "noventa"
    );

    if (tn > 0 || one > 0) {
      if (tn < 2) {
        res += ones[tn * 10 + one];
      } else {
        if (tn === 2 && one > 0) res += "veinti" + ones[one];
        else {
          res += tens[tn];
          if (one > 0) {
            res += " y " + ones[one];
          }
        }
      }
    }

    if (res == "") {
      res = "cero";
    }
    return res.replace("  ", " ");
  }

  pad(num, largo, char) {
    char = char || "0";
    num = num + "";
    return num.length >= largo
      ? num
      : new Array(largo - num.length + 1).join(char) + num;
  }
}
